import {BlobContent} from './BlobContent'

// eslint-disable-next-line no-barrel-files/no-barrel-files
export default BlobContent
